<template>
  <div class="get-lipi">
  </div>
</template>


<style lang="scss" scoped>
</style>
<script>
export default {
  name: "get-lipi",

metaInfo: {
    title: "Lipi for Business - POS, Accounting, Inventory",
    meta: [
      {
        name: "description",
        content:
          "ব্যবসার সকল দিক পরিচালনার জন্য সহজ একটি অ্যাপ - Lipi is easy-to-adopt in your business and easy-to-use daily"
      },
      {
        name: "keywords",
        content:
          "Lipi, POS, Point of Sale, ERP, Bangla ERP, SaaS, CRM, Accounting, Inventory, Business Management, Customer Management, Vendor Management, Android POS App, Android ERP, Cloud POS, Cloud ERP, Bangladesh, Bangladesh Startup"
      }
    ]
  },

  mounted: function(){
      window.location = "https://play.google.com/store/apps/details?id=live.lipi.lipilite&hl=en&gl=US"
  }
};
</script>
